import Vue from 'vue'
import VueRouter from 'vue-router'
import getPageTitle from '@/utils/title'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/chitchat'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: "登录"
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('../views/Chat.vue'),
    meta: {
      title: "AI客服"
    }
  },
  {
    path: '/chitchat',
    name: 'chitchat',
    component: () => import('../views/Chitchat.vue'),
    meta: {
      title: "卓远智慧招投标智慧客服"
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title)
  next()
})

export default router
